// extracted by mini-css-extract-plugin
var _1 = "moOIM";
var _2 = "pF9ue";
var _3 = "daa_G";
export { _1 as "body", _2 as "graph", _3 as "table" }
